const isIterable = (obj) => {
	if (obj === null || obj === undefined) {
		return false;
	}

	return typeof obj[Symbol.iterator] === "function";
};

export default isIterable;
